// extracted by mini-css-extract-plugin
export default {"message-container":"Comment_message-container__iDYmG","author":"Comment_author__4ukrR","comment":"Comment_comment__jO0u8","date":"Comment_date__8PWCe"};